// extracted by mini-css-extract-plugin
export default {"wrapper":"ecXpu","count":"b7b3m"};